import { toPercent } from '@aibees/shared/utils';
import { useCurrentSubscriptionApi } from '../api/use-current-subscription-api';

export function useCurrentPlanInfo() {
  const { data } = useCurrentSubscriptionApi();

  const credit =
    (data?.credit?.total || 0) -
    ((data?.credit?.total || 0) > Number(data?.current?.plan?.metadata.request)
      ? (data?.credit?.total || 0) -
        Number(data?.current?.plan?.metadata.request)
      : 0);

  const rollOver =
    Number(data?.credit?.total) > Number(data?.current?.plan?.metadata.request)
      ? Number(data?.credit?.total) -
        Number(data?.current?.plan?.metadata.request)
      : 0;

  const lowOnCredit =
    toPercent(credit, Number(data?.current?.plan?.metadata.request)) < 5;

  const ranOutOfCredit = data?.credit?.total === 0;

  return { credit, rollOver, lowOnCredit, ranOutOfCredit };
}
